import { v4 as uuid } from 'uuid';
import EventSubscriber from './EventSubscriber';

interface PropsShape {
  eventName?: string;
  preventPageUnload?: boolean;
  eventProps?: Array<unknown>;
}

const PageManager = (): {
  beforeUnload: (
    pageUnloader: (...args: Array<unknown>) => unknown,
    props?: PropsShape
  ) => string;
  unsubscribeBeforeOnload: (eventName: string) => void;
} => {
  const pageEventSubscriber = EventSubscriber();

  const beforeUnload = (
    pageUnloader: (...args: Array<unknown>) => unknown,
    propsParam: PropsShape
  ) => {
    const props = propsParam || {};

    const {
      eventName = uuid(),
      preventPageUnload = false,
      eventProps = [],
    } = props;

    const eventHandler = (event: Event) => {
      if (preventPageUnload) {
        event.preventDefault();
      }
      pageUnloader(...eventProps);
    };

    pageEventSubscriber.subscribe(eventName, eventHandler);
    window.addEventListener('beforeunload', eventHandler);

    return eventName;
  };

  const unsubscribeBeforeOnload = (eventName: string): void => {
    const eventHandler = pageEventSubscriber.getEvent(eventName);
    pageEventSubscriber.unsubscribe(eventName);
    window.removeEventListener('beforeunload', eventHandler);
  };

  return {
    beforeUnload,
    unsubscribeBeforeOnload,
  };
};

export default PageManager;
